export default "__VITE_ASSET__DnV_oPxG__"